module.exports = __webpack_public_path__ + "static/fram-signature-854084dbb245d384278f0bed3f80bd8c.svg";